import React, { useEffect, useState } from 'react';
import { Modal, Box, CircularProgress, Stack } from '@mui/material';
import { fontWeight, lineHeight, styled } from '@mui/system';
import TabNavigation from '../Tabs';
import { getTotalStorage } from '../../../services/api';
import { setStorage } from '../../../redux/reducers/storage';
import { useDispatch, useSelector } from 'react-redux';
import MediaTable from '../MediaTable';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import TextView from '../../TextView';
import { ASSETS } from '../../../utils/config';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useNavigate } from 'react-router-dom';

const StyledModal = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalContent = styled(Box)`
  background-color: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0px 0px 9.3px 0px #3b3b3b1c;
  text-align: center;
  height: 75vh;
  width: 65vw;
  overflow-y: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none;  /* Internet Explorer 10+ */
  &::-webkit-scrollbar { 
    display: none;  /* Safari and Chrome */
  }
`;

function StorageMediaModal({ isOpen = false, onClose = () => { }, title = "Wheel", wheelId = 0, image, size }) {
    const [loading, setLoading] = useState(true); // Add loading state
    const [selectedCategory, setSelectedCategory] = useState('Images');
    const dispatch = useDispatch();
    const nav = useNavigate();

    const {
        audiosStorage,
        documentsStorage,
        imagesStorage,
        wheelsStorage,
        videosStorage,
    } = useSelector((state) => state.storage);

    const handleCategoryChange = (event, newTab) => {
        setSelectedCategory(newTab);
    };

    const fetchMedia = async () => {
        try {
            const response = await getTotalStorage();
            console.log('sitass', response.data.data);
            dispatch(setStorage(response.data.data)); // Dispatch setStorage action
        } catch (err) {
            console.error('Failed to fetch Media:', err);
        } finally {
            setLoading(false); // Set loading to false once data is fetched
        }
    };

    useEffect(() => {
        if (isOpen) {
            fetchMedia();
        }
    }, [isOpen]);

    const renderTabContent = () => {
        switch (selectedCategory) {
            case 'Images':
                return <MediaTable type="images" fetchMedia={fetchMedia} wheelId={wheelId} />;
            case 'Videos':
                return <MediaTable type="videos" fetchMedia={fetchMedia} wheelId={wheelId} />;
            case 'Audios':
                return <MediaTable type="audios" fetchMedia={fetchMedia} wheelId={wheelId} />;
            case 'Documents':
                return <MediaTable type="documents" fetchMedia={fetchMedia} wheelId={wheelId} />;
            default:
                return <MediaTable type="images" fetchMedia={fetchMedia} wheelId={wheelId} />;
        }
    };

    return (
        <StyledModal
            open={isOpen}
            onClose={onClose}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
        >
            <ModalContent>
                {loading ? (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '50vh',
                        }}
                    >
                        <CircularProgress />
                    </div>
                ) : (
                    <>
                        <Stack display={"flex"} flexDirection={"row"} justifyContent={'space-between'} alignItems={'center'} style={{ paddingBottom: '15px', borderBottom: '1px solid #E0E0E0', marginBottom: '20px' }}>
                            <Stack display={"flex"} flexDirection={"row"} justifyContent={'flex-start'} alignItems={'center'}>
                                <ArrowBackIcon style={{ fontSize: '26px', marginLeft: '8px', cursor: 'pointer' }} onClick={onClose} />
                                <img
                                    alt="default"
                                    src={image || ASSETS.wheel_img}
                                    style={{ marginLeft: '20px', height: '48px', width: '48px', borderRadius: '5px' }}
                                />
                                <TextView style={{ fontSize: '28px', fontWeight: '700', color: '#0F0F0F', marginLeft: '10px', lineHeight: '35px' }}>{title.replace(/<[^>]*>/g, '')}</TextView>
                                <OpenInNewIcon style={{ fontSize: '25px', marginLeft: '8px', color: '#9B5AF8', cursor: 'pointer' }} onClick={() => nav(`/wheel/${wheelId}`)} />
                            </Stack>
                            <Stack display={"flex"} flexDirection={"column"} justifyContent={'flex-start'} alignItems={'flex-end'}>
                                <TextView style={{ color: '#98A2B3', fontWeight: '500', fontSize: '15px', }}>Total Storage</TextView>
                                <TextView style={{ fontSize: '25px', fontWeight: '700', color: '#0F0F0F', marginTop: '5px', lineHeight: '35px' }}>{size}</TextView>
                            </Stack>
                        </Stack>
                        <TabNavigation
                            selectedCategory={selectedCategory}
                            handleCategoryChange={handleCategoryChange}
                            storage={[audiosStorage, documentsStorage, imagesStorage, wheelsStorage, videosStorage]}
                        />
                        {renderTabContent()}
                    </>
                )}
            </ModalContent>
        </StyledModal>
    );
}

export default StorageMediaModal;